import React from 'react'
import Navbar from '../Components/Navbar/Navbar'
import Contactus from '../Components/Contactus/Contactus'
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Common/Header'
import PortfolioGrid from "../Components/Services/PortfolioGrid";
import { useSelector } from 'react-redux'

function Portfolio() {
        const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <>
    <Navbar/>

        <div className={"serviceContainer"}>
      <Header title={currentLocal.general.portfolio} />
      {/* <Service state={true} /> */}
            <PortfolioGrid/>

    </div>
    <Contactus/>
    <Footer/>
      
    </>
  )
}

export default Portfolio
